import Breadcrumb from "components/Common/Breadcrumb2"
import toast from "components/Toast/Toast"

import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"

import useInterval from "hooks/useInterval"
import useIsDarkTheme from "hooks/useIsDarkTheme"
import { useUser } from "hooks/useUser"
import moment from "moment"
import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import BootstrapTable from "react-bootstrap-table-next"
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit"
import { withTranslation } from "react-i18next"
import { Link } from "react-router-dom"
import Select from "react-select"
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Spinner,
  UncontrolledTooltip,
} from "reactstrap"
import {
  getCheckBoxes,
  getRequests,
  getRequestsChannelTypes,
  getRequestsQueueTypes,
  getRequestsStepTypes,
  getRequestsTypes,
  moveQueue,
} from "services/support/calls"
import * as OrderService from "../../services/orders/calls"
import ChamadosModal from "./ChamadosModal"
import { postReport } from "services/orders/tracking/calls"

const { REACT_APP_MAX_LINES_EXPORT } = process.env || 10000

const Chamados = props => {
  const { t } = props
  document.title = "Chamados | Sensetek"
  moment.locale("pt-br")

  const [requestUser, setRequestUser] = useState(false)
  const { payload } = useUser(requestUser)

  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState("")
  const [requests, setRequests] = useState([])
  const [users, setUsers] = useState([])
  const [limit] = useState(20)
  const [isFirstPage, setIsFirstPage] = useState(true)
  const [isLastPage, setIsLastPage] = useState(false)
  const [alert, setAlert] = useState(null)

  const [fileType, setFileType] = useState([])
  const [baseType, setBaseType] = useState([])
  const [attributesModal, openAttributesModal] = useState(false)
  const [checkboxes, setCheckboxes] = useState([])
  const [types, setRequestsTypes] = useState([])
  const [stepTypes, setRequestsStepTypes] = useState([])
  const [stepFechado, setStepFechado] = useState(null)
  const [queueAutomatica, setQueueAutomatica] = useState(null)
  const [channels, setChannels] = useState([])
  const [queues, setQueues] = useState([])
  const [modalHistorico, setModalHistorico] = useState(false)
  const [modalHistoricoContent, setmodalHistoricoContent] = useState([])
  const [refreshDropDown, setRefreshDropDown] = useState(false)
  const [showConfirm, setShowConfirm] = useState(false)
  const [confirm, setConfirm] = useState({})

  const [isOpenTable, handleOpenTable] = useState(true)

  const defaultSorted = [
    {
      dataField: "id",
      order: "asc",
    },
  ]
  const selectRow = {
    mode: "checkbox",
    hideSelectColumn: true,
  }

  const tipoChamadoHandleChange = options => {
    let lista = options ? options.map(items => items.value) : []
    setFilters({
      ...filters,
      types: lista,
    })
  }

  const channelHandleChange = options => {
    let lista = options ? options.map(items => items.value) : []
    setFilters({
      ...filters,
      channel: lista,
    })
  }

  const queueHandleChange = options => {
    let lista = options ? options.map(items => items.value) : []
    setFilters({
      ...filters,
      queue: lista,
    })
  }

  const [page, setPage] = useState(1)
  const [currentPage, setCurrentPage] = useState(1)
  const [filters, setFilters] = useState({
    assignment: "forMe",
    status: "all",
    criteria: "desc",
    types: [],
    channel: [],
    queue: [],
    chave: "",
    startAt: moment().subtract(7, "d").toDate(),
    endAt: new Date(),
  })
  const [total, setTotal] = useState(0)
  const [activeRequest, setActiveRequest] = useState(null)
  const [modal, setModal] = useState(false)

  const [exportModal, setExportModal] = useState(false)
  const [exportFile, setExportFile] = useState([])
  const [, setLoadingFile] = useState(false)
  const [isReady, setReady] = useState(false)

  const [interval, setInterval] = useState(15000)

  const intervalRef2 = useInterval(
    () => {
      latest()
    },
    activeRequest ? null : interval
  )

  const generateExport = () => {
    setExportFile([])
    const length = checkboxes.filter(checkbox => checkbox.checked).length
    setLoadingFile(true)
    fetchReportOrders(filters, fileType, baseType)
    setExportModal(false)
  }

  const fetchReportOrders = async (filters, fileType, baseType) => {
    let addToQueue = false
    if (total > REACT_APP_MAX_LINES_EXPORT) {
      addToQueue = true
      setReady(true)
    }
    setError(false)
    try {
      await postReport(
        filters || query,
        addToQueue,
        payload.id,
        fileType,
        baseType,
        checkboxes.filter(checkbox => checkbox.checked),
        total
      )
      toast("success", "Pedido realizado com sucesso!", "Exportação")
    } catch (err) {
      console.log(err)
      toast("error", "Problema ao executar o pedido.", "Erro")
      setError(err)
    }
  }

  const toggleModal = () => {
    setModal(!modal)
  }

  const isDarkTheme = useIsDarkTheme()

  const columns = [
    {
      dataField: "id",
      text: "ID",
      sort: false,
      formatter: (cellContent, row) => <b>{cellContent}</b>,
    },
    {
      dataField: "order.shippingTrackerCode",
      text: t("AR"),
      sort: false,
    },
    {
      dataField: "channel.name",
      text: t("Canal de Atendimento"),
      sort: false,
    },
    {
      dataField: "type.name",
      text: t("Tipo de chamado"),
      sort: false,
    },
    {
      dataField: "currentQueueType.name",
      text: t("Fila"),
      sort: false,
    },
    {
      dataField: "order.shippingCompany.name",
      text: t("Transportadora"),
      sort: false,
    },
    {
      dataField: "currentStepType.name",
      text: t("Situação"),
      sort: false,
      formatter: (cellContent, row) => cellContent || "-",
    },
    {
      dataField: "createdAt",
      text: t("Data de Criação"),
      sort: false,
      formatter: (cellContent, row) => (
        <b>
          {moment(cellContent, "YYYY-MM-DD HH:mm:ss")
            .add(-3, "hours")
            .format("DD/MM/YYYY HH:mm:ss")}
        </b>
      ),
    },

    //{
    //  dataField: "dummyCreatedAt",
    //  isDummyField: true,
    //  text: t("Prazo - Estimativa"),
    //  sort: false,
    //  formatter: (cellContent, row) => (
    //    <b>
    //      {moment(row.createdAt, "YYYY-MM-DD")
    //        .add(5, "days")
    //        .format("DD/MM/YYYY")}
    //    </b> // DEFINIR SLA COM HUGO
    //  ),
    //},

    //{
    //  dataField: "Ciclo",
    //  isDummyField: true,
    //  text: t("Ciclo"),
    //  sort: false,
    //  formatter: (cellContent, row) => "Dentro do prazo",
    //},

    {
      dataField: "order.currentStatus.name",
      text: t("Status Pedido"),
      sort: false,
    },
    {
      dataField: "details",
      isDummyField: true,
      text: t("Detalhes"),
      align: "center",
      formatter: (cellContent, row, rowIndex, formatExtraData) => (
        <>
          <ul className="list-unstyled hstack gap-1 mb-0">
            <li data-bs-toggle="tooltip" data-bs-placement="top">
              <Link
                to="#"
                className={`btn btn-sm btn-${
                  formatExtraData["darkTheme"] ? "soft-" : ""
                }primary`}
                onClick={() => {
                  // clearInterval(intervalFunc)
                  // clearInterval(intervalRef.current)
                  if (row.lockedBy === null) {
                    setActiveRequest(row)
                    setModal(true)
                  }
                }}
                // disabled={row.lockedBy !== null}
              >
                <i
                  className={`mdi ${
                    row.lockedBy !== null ? "mdi-lock" : "mdi-eye-outline"
                  }`}
                  // "mdi mdi-eye-outline"
                  id={`viewtooltip${row.id}`}
                ></i>
              </Link>
              <UncontrolledTooltip
                placement="top"
                target={`viewtooltip${row.id}`}
              >
                {row.lockedBy !== null
                  ? `Chamado em andamento por: ${row.locked?.name}`
                  : t("Visualizar")}
              </UncontrolledTooltip>
            </li>
            {/* {row.currentStepType?.id !== stepFechado?.id &&
              !row.currentQueueType?.isAuto && (
                <li data-bs-toggle="tooltip" data-bs-placement="top">
                  <Link
                    to="#"
                    className={`btn btn-sm btn-${
                      formatExtraData["darkTheme"] ? "soft-" : ""
                    }primary`}
                    onClick={() => {
                      setConfirm({
                        title: "Confirmação",
                        body: "Tem certeza que deseja enviar este chamado para fila Automática novamente?",
                        onConfirm: () => {
                          handleMoveQueue(row.id)
                        },
                      })
                      setShowConfirm(true)
                    }}
                    disabled={row.lockedBy !== null}
                  >
                    <i
                      className={`mdi mdi-redo`}
                      // "mdi mdi-eye-outline"
                      id={`autoTooltip${row.id}`}
                    ></i>
                  </Link>
                  <UncontrolledTooltip
                    placement="top"
                    target={`autoTooltip${row.id}`}
                  >
                    {t("Automático")}
                  </UncontrolledTooltip>
                </li>
              )} */}
          </ul>
        </>
      ),
      formatExtraData: {
        darkTheme: isDarkTheme,
      },
    },
  ]

  // const handleMoveQueue = async id => {
  //   try {
  //     setIsLoading(true)

  //     const payload = await moveQueue({
  //       supportRequestId: id,
  //       queueId: queueAutomatica?.id,
  //     })
  //     latest()
  //   } catch (error) {
  //     console.log(error)
  //   } finally {
  //     setIsLoading(false)
  //   }
  // }

  const latest = async _page => {
    try {
      setIsLoading(true)
      const { payload } = await getRequests(_page || page, filters, limit)
      const { supports, users, count, locked } = payload
      setRequests(supports)
      setTotal(count)
      setUsers(users)
      const maxPages = Math.ceil(count / limit)
      setIsLastPage((count ? _page || page : 1) === maxPages)
      if (locked) {
        setActiveRequest(locked)
        setModal(true)
      }
    } catch (error) {
      setError(error)
    } finally {
      setIsLoading(false)
    }
  }

  const getRequestsTypesSteps = async () => {
    const restype = await getRequestsTypes()
    const { types: resTypes } = restype.payload
    setRequestsTypes(
      resTypes.map(e => {
        return { value: e.id, label: e.name }
      })
    )
    const resstep = await getRequestsStepTypes()
    const { types: resSteps } = resstep.payload
    setStepFechado(resSteps?.filter(rs => rs.isLast)[0])
    setRequestsStepTypes(
      resSteps.map(e => {
        return { value: e.id, label: e.name }
      })
    )
  }

  const getRequestChannels = async () => {
    const reschannels = await getRequestsChannelTypes()
    const { types: resChannels } = reschannels.payload
    setChannels(
      resChannels.map(e => {
        return { value: e.id, label: e.name }
      })
    )
  }

  const getRequestQueues = async () => {
    const resqueues = await getRequestsQueueTypes()
    const { types: resQueues } = resqueues.payload
    setQueueAutomatica(resQueues?.filter(rq => rq.isAuto)[0])
    setQueues(
      resQueues.map(e => {
        return { value: e.id, label: e.name }
      })
    )
  }

  const sortByColumnName = (a, b) => {
    var textA = a.title.toUpperCase()
    var textB = b.title.toUpperCase()
    return textA < textB ? -1 : textA > textB ? 1 : 0
  }

  const fetchOrders = async (filters, offset) => {
    setError(false)
    try {
      const resCheckboxes = await getCheckBoxes()
      const { checkboxes } = resCheckboxes
      setCheckboxes(
        checkboxes.sort(sortByColumnName).map((c, i) => ({
          ...c,
          checked: true,
        }))
      )
    } catch (err) {
      setError(err)
    }
  }

  useEffect(() => {
    setIsLoading(true)
    setFileType("xlsx")
    setBaseType("chamados")
    openAttributesModal(false)
    try {
      getRequestsTypesSteps()
      getRequestChannels()
      getRequestQueues()
      latest()
      fetchOrders()
    } catch (error) {
      console.log(error)
      setError(error)
    }
  }, [])

  const onQuery = e => {
    e.preventDefault()
    setIsLoading(true)
    setPage(1)
    setCurrentPage(1)
    setIsFirstPage(true)
    latest(1)
  }

  const pages = total ? Math.ceil(total / limit) : 0

  const snapToPage = page => {
    if (currentPage + page > 0) {
      setIsLoading(true)
      const newPage = currentPage + page
      setCurrentPage(newPage)
      setPage(newPage)
      setIsFirstPage(newPage == 1 ? true : false)
      latest(newPage)
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb
            title={props.t("Chamados")}
            breadcrumbItems={[
              { title: props.t("Consulta de Chamados"), path: "#" },
            ]}
          />
          <Row>
            <Col>
              <Card className="mb-0">
                <CardHeader tag={"h4"} className="bg-primary text-white">
                  <Row className="hstack">
                    <Col>Filtro</Col>
                    <Col>
                      <Dropdown
                        isOpen={refreshDropDown}
                        toggle={() => setRefreshDropDown(!refreshDropDown)}
                        className="mt-4 mt-sm-0 float-end"
                      >
                        <DropdownToggle className="btn btn-secondary" caret>
                          <i className="bx bx-alarm d-block"></i>
                          Refresh{" "}
                          {interval ? `${interval / 1000}s` : "desativado"}
                        </DropdownToggle>
                        <DropdownMenu>
                          <DropdownItem
                            onClick={() => {
                              setInterval(null)
                              setRefreshDropDown(false)
                            }}
                          >
                            Desativar
                          </DropdownItem>
                          <DropdownItem
                            onClick={() => {
                              setInterval(5000)
                              setRefreshDropDown(false)
                            }}
                          >
                            5s
                          </DropdownItem>
                          <DropdownItem
                            onClick={() => {
                              setInterval(10000)
                              setRefreshDropDown(false)
                            }}
                          >
                            10s
                          </DropdownItem>
                          <DropdownItem
                            onClick={() => {
                              setInterval(15000)
                              setRefreshDropDown(false)
                            }}
                          >
                            15s
                          </DropdownItem>
                          <DropdownItem
                            onClick={() => {
                              setInterval(30000)
                              setRefreshDropDown(false)
                            }}
                          >
                            30s
                          </DropdownItem>
                        </DropdownMenu>
                      </Dropdown>
                    </Col>
                    <Col sm={1}>
                      <button
                        type="button"
                        className="btn btn-secondary btn-block float-end"
                        disabled={requests.length === 0}
                        onClick={() => {
                          setExportModal(true)
                        }}
                      >
                        <i className="bx bx-export d-block"></i> Exportar
                      </button>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody>
                  <Form className="form-horizontal" onSubmit={onQuery}>
                    <Row>
                      <Col sm={2}>
                        <FormGroup
                          className="form-check"
                          style={{ paddingLeft: "0px" }}
                        >
                          <Label>{t("Chave")}</Label>
                          <Input
                            name="chave"
                            value={filters.chave}
                            onChange={e => {
                              setFilters({
                                ...filters,
                                chave: e.target.value,
                              })
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col lg={1}>
                        <FormGroup controlid="ordersStartDateRef">
                          <Label>Início</Label>
                          <DatePicker
                            dateFormat="dd/MM/yyyy"
                            className="form-control"
                            selected={filters.startAt}
                            selectsStart
                            startDate={filters.startAt}
                            endDate={filters.endAt}
                            onChange={e => {
                              setFilters({
                                ...filters,
                                startAt: e,
                              })
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col lg={1}>
                        <FormGroup controlid="ordersEndDateRef">
                          <Label>Fim</Label>
                          <DatePicker
                            dateFormat="dd/MM/yyyy"
                            className="form-control"
                            selected={filters.endAt}
                            selectsEnd
                            startDate={filters.startAt}
                            endDate={filters.endAt}
                            onChange={e => {
                              setFilters({
                                ...filters,
                                endAt: e,
                              })
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col lg={2}>
                        <FormGroup>
                          <Label>{t("Situação")}</Label>
                          <Select
                            options={stepTypes}
                            placeholder={t("Situação")}
                            onChange={e => {
                              if (!e) {
                                setFilters({
                                  ...filters,
                                  status: "all",
                                })
                                return
                              }
                              setFilters({
                                ...filters,
                                status: e.value,
                              })
                            }}
                            isClearable={true}
                            menuPortalTarget={document.body}
                          />
                        </FormGroup>
                      </Col>
                      <Col lg={2}>
                        <FormGroup>
                          <Label>{t("Tipo de chamado")}</Label>
                          <Select
                            isMulti
                            options={types}
                            placeholder={t("Tipo de chamado")}
                            onChange={tipoChamadoHandleChange}
                            isClearable={true}
                          />
                        </FormGroup>
                      </Col>
                      <Col lg={2}>
                        <FormGroup>
                          <Label>{t("Canal de Atendimento")}</Label>
                          <Select
                            isMulti
                            options={channels}
                            placeholder={t("Canal de Atendimento")}
                            onChange={channelHandleChange}
                            isClearable={true}
                          />
                        </FormGroup>
                      </Col>
                      <Col lg={2}>
                        <FormGroup>
                          <Label>{t("Fila")}</Label>
                          <Select
                            isMulti
                            options={queues}
                            placeholder={t("Fila")}
                            onChange={queueHandleChange}
                            isClearable={true}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <div
                      className="d-flex flex-row-reverse vstack gap-2"
                      style={{
                        display: "flex",
                        alignItems: "flex-end",
                      }}
                    >
                      <button
                        className="btn btn-primary btn-block"
                        type="submit"
                      >
                        {t("Filtrar")}
                      </button>
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col>
              <Card>
                <CardHeader tag={"h4"} className="bg-primary text-white">
                  <Row className="hstack">
                    <Col>Resultado</Col>
                  </Row>
                </CardHeader>
                <CardBody>
                  {!isLoading &&
                    (requests?.length > 0 ? (
                      <ToolkitProvider
                        keyField="id"
                        columns={columns}
                        columnToggle
                        data={requests}
                        search
                      >
                        {toolkitProps => (
                          <React.Fragment>
                            <Row>
                              <Col xl="12" className="table-responsive">
                                <BootstrapTable
                                  keyField={"id"}
                                  bordered={true}
                                  striped={true}
                                  defaultSorted={defaultSorted}
                                  selectRow={selectRow}
                                  classes={"table align-middle table-nowrap"}
                                  headerWrapperClasses={"thead-light"}
                                  {...toolkitProps.baseProps}
                                />
                              </Col>
                            </Row>
                            {total > 0 && (
                              <Row className="align-items-md-center mt-30">
                                <Col className="inner-custom-pagination d-flex">
                                  <div className="d-inline">
                                    <span className="react-bootstrap-table-pagination-total">
                                      {t("Registros Retornados")}: {total}
                                    </span>
                                  </div>
                                  <div className="text-md-right ms-auto">
                                    <button
                                      className="btn btn-outline-primary "
                                      disabled={isFirstPage || isLoading}
                                      onClick={() => snapToPage(-1)}
                                    >
                                      {t("Anterior")}
                                    </button>
                                    <button
                                      className="btn btn-outline-primary "
                                      disabled={true}
                                    >
                                      {currentPage}/{pages}
                                    </button>
                                    <button
                                      className="btn btn-outline-primary "
                                      disabled={isLastPage || isLoading}
                                      onClick={() => snapToPage(1)}
                                    >
                                      {t("Próximo")}
                                    </button>
                                  </div>
                                </Col>
                              </Row>
                            )}
                          </React.Fragment>
                        )}
                      </ToolkitProvider>
                    ) : (
                      <div style={{ textAlign: "center" }}>
                        <h5>{t("Nenhum dado encontrado.")}</h5>
                      </div>
                    ))}
                  {isLoading && (
                    <div
                      className="accordion-body"
                      style={{ textAlign: "center" }}
                    >
                      <Spinner className="ms-2" color="primary" />
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <Modal
        isOpen={exportModal}
        size="xl"
        toggle={() => {
          toggleModal()
        }}
        centered
      >
        <ModalHeader>
          Exportação de Dados
          <button
            type="button"
            onClick={() => {
              setExportModal(false)
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col>
              <div className="form-group">
                <label htmlFor="key" style={{ textAlign: "left" }}>
                  Exportar como:
                </label>
                <div className="form-row ml-0">
                  <div className="form-group form-check ml-2">
                    <input
                      className="form-check-input"
                      name="fileType"
                      value="xlsx"
                      id="xlsType"
                      type="radio"
                      checked={fileType === "xlsx"}
                      onChange={e => {
                        setFileType(e.target.value)
                        setCheckboxes(prev => {
                          return prev.map(c => ({ ...c, checked: true }))
                        })
                      }}
                    />
                    <label htmlFor="xlsType"> Excel </label>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <Row className="mb-2">
            <Col className="hstack gap-2">
              <Button
                className="btn-rounded"
                size="sm"
                onClick={() => {
                  setCheckboxes(
                    checkboxes.map((c, i) => ({
                      ...c,
                      checked: true,
                    }))
                  )
                }}
              >
                Marcar Todos
              </Button>
              <Button
                className="btn-rounded"
                size="sm"
                onClick={() => {
                  const cbs = checkboxes.map((c, i) => ({
                    ...c,
                    checked: false,
                  }))
                  setCheckboxes(cbs)
                }}
              >
                Desmarcar Todos
              </Button>
            </Col>
          </Row>
          <Row>
            <label style={{ textAlign: "left" }}>Informações:</label>
            <div className="d-flex">
              {_.chunk(checkboxes, 17).map((columns, i) => {
                return (
                  <Col key={"checkboxes-column-" + i}>
                    {columns.map(checkbox => {
                      return (
                        <div
                          key={"checkboxes-key-" + checkbox.column}
                          className="form-check"
                          style={{ marginBottom: 8 }}
                        >
                          <input
                            className="form-check-input"
                            name={checkbox.column}
                            id={checkbox.column}
                            type="checkbox"
                            checked={checkbox.checked}
                            onChange={e => {
                              const checkedColumn = e.target.checked
                              setCheckboxes(prev => {
                                return prev.map(c => {
                                  if (c.column === checkbox.column)
                                    return {
                                      ...c,
                                      checked: checkedColumn,
                                    }
                                  return c
                                })
                              })
                            }}
                          />
                          <label
                            className="form-check-label"
                            htmlFor={checkbox.column}
                          >
                            {checkbox.title}
                          </label>
                        </div>
                      )
                    })}
                  </Col>
                )
              })}
            </div>
          </Row>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-light"
            onClick={() => {
              setExportModal(false)
            }}
          >
            Cancelar
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => {
              generateExport()
            }}
          >
            Gerar Exportação
          </button>
        </ModalFooter>
      </Modal>
      {activeRequest && (
        <ChamadosModal
          isShow={activeRequest !== null}
          setActiveRequest={setActiveRequest}
          activeRequest={activeRequest}
          resetQueue={latest}
        />
      )}
      <Modal
        isOpen={modalHistorico}
        toggle={() => {
          setModalHistorico(!modalHistorico)
        }}
        centered
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myModalLabel">
            <p>Detalhes</p>
          </h5>
          <button
            type="button"
            onClick={() => {
              setModalHistorico(false)
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          {Object.keys(modalHistoricoContent).map((e, i) => {
            return (
              <p key={i}>
                <b>
                  {moment(e, "YYYY-MM-DD HH:mm:ss").format(
                    "DD/MM/YYYY HH:mm:ss"
                  )}
                  :
                </b>
                {` ${modalHistoricoContent[e].message}`}
              </p>
            )
          })}
        </div>
        <div className="modal-footer">
          <button
            type="button"
            onClick={() => {
              setModalHistorico(false)
            }}
            className="btn btn-primary"
            data-dismiss="modal"
          >
            {props.t("Ok")}
          </button>
        </div>
      </Modal>
      <Modal
        isOpen={showConfirm}
        toggle={() => {
          setShowConfirm(!showConfirm)
        }}
        centered
        onClosed={() => {
          setIsLoading(true)
          latest()
        }}
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myModalLabel">
            <p>{confirm?.title}</p>
          </h5>
          <button
            type="button"
            onClick={() => {
              setShowConfirm(false)
              {
                confirm
              }
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">{confirm?.body}</div>
        <div className="modal-footer">
          <button
            type="button"
            onClick={() => {
              setShowConfirm(false)
            }}
            className="btn btn-secondary"
            data-dismiss="modal"
          >
            {props.t("Cancelar")}
          </button>
          <button
            type="button"
            onClick={() => {
              setShowConfirm(false)
              confirm?.onConfirm()
            }}
            className="btn btn-primary"
            data-dismiss="modal"
          >
            {props.t("Confirmar")}
          </button>
        </div>
      </Modal>
    </React.Fragment>
  )
}

Chamados.propTypes = {
  t: PropTypes.any,
}

export default withTranslation()(Chamados)
